<button mat-raised-button class="md-small" color="primary" (click)="generarlistapdf()">
        <mat-icon fontSet="fontawesome" fontIcon="fa-file-pdf-o" ></mat-icon>
</button>